/* eslint-disable jsx-a11y/label-has-associated-control */
import { Chip, FormControl, Grid, Radio, Typography, makeStyles } from '@material-ui/core';
import React from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { useSelector } from 'react-redux';
import Image from '../common/Image';
import MultiSelectAll from '../common/search/MultiSelectSearch';
import UploadButton from '../journey/UploadButton';
import VideoUploadButton from '../journey/VideoUploadButton';
import CustomUploadField from '../shared/CustomUploadField';
import { DIMENSIONS } from '../../constants/aspectRatio';
import AntSwitch from '../dailydose/AntSwitch';

const useStyle = makeStyles({
  certBox: {
    height: '60vh',
    overflowY: 'auto',
    background: '#F2F4F7',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    padding: '10px 20px',
  },
  required_field: {
    color: '#667085',
    '&:after': {
      content: "' *'",
      color: '#F50000',
    },
  },
  optional_field: {
    color: '#667085',
  },
  inputField: {
    width: '95%',
    padding: '15px 10px',
    borderRadius: '5px',
    border: '1px solid #E4E7EC',
    outline: 'none',
    marginTop: '5px',
    background: '#FEFEFE',
  },
  upload: {
    border: '1px solid #E4E7EC',
    padding: '7px',
    marginTop: '5px',
    width: '96%',
    borderRadius: '5px',
    background: '#FEFEFE',
  },
  charLimit: {
    display: 'flex',
    width: '97%',
    justifyContent: 'space-between',
  },
  radioBtn: {
    color: '#622fee',
    width: '5px',
    height: '5px',
  },
  skill: {
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
  },
});

export const CertInfo = ({
  certInfo,
  setCertInfo,
  certUrl,
  certImg,
  setCertImg,
  distinctionImg,
  thumbnailImg,
  distinctionUrl,
  thumbnailUrl,
  setDistinctionImg,
  setThumbnailUrl,
  setThumbnailImg,
  videoFile,
  setVideoFile,
  videoUrl,
  setVideoUrl,
  setCertUrl,
  setDistinctionUrl,
  deptList,
  setSelectedDeptIds,
  selectedDeptIds,
  selectedCertIds,
  setSelectedCertIds,
  certList,
  isAssignable,
  setIsAssignable,
  isEdit,
  setExpDate,
  expDate,
}) => {
  const classes = useStyle();

  const REPORTING_CODE_CHAR_LIMIT = 20;

  const selectedCertInfoEdit = useSelector((state) => state.certificateData.selectedCertInfoEdit);

  const handleDeletePassedCert = () => {
    setCertImg(null);
    setCertUrl('');
  };
  const handleDeleteDistCert = () => {
    setDistinctionImg(null);
    setDistinctionUrl('');
  };

  const handleDeleteThumbnail = () => {
    setThumbnailImg(null);
    setThumbnailUrl('');
  };

  const handleChange = (e, name) => {
    const val = e.target.value;
    if (name === 'code' && val.length <= 8 && !isEdit) {
      setCertInfo((pre) => ({
        ...pre,
        [name]: e.target.value,
      }));
    } else if (name === 'name' && val.length <= 50) {
      setCertInfo((pre) => ({
        ...pre,
        [name]: e.target.value,
      }));
    } else if (name === 'overview' && val.length <= 150) {
      setCertInfo((pre) => ({
        ...pre,
        [name]: e.target.value,
      }));
    } else if (name === 'courseCode') {
      const cleanedVal = val.replace(/\s/g, '').slice(0, REPORTING_CODE_CHAR_LIMIT);
      setCertInfo((pre) => ({
        ...pre,
        [name]: cleanedVal,
      }));
    } else if (!(name === 'name' || name === 'overview' || name === 'code' || name === 'courseCode')) {
      setCertInfo((pre) => ({
        ...pre,
        [name]: e.target.value,
      }));
    }
  };
  const handleMultiDept = (valueObj) => {
    setSelectedDeptIds(valueObj);
  };
  const handleMultiCert = (valueObj) => {
    setSelectedCertIds(valueObj);
  };
  const handleThumbnailUpload = (e) => {
    const file = e.target.files[0];
    setThumbnailImg(file);
    const reader = new FileReader();
    reader.onload = (ev) => {
      setThumbnailUrl(ev.target.result);
    };
    reader.readAsDataURL(file);
  };
  const handleImageUpload = (e) => {
    const filesData = e.target.files[0];
    setCertImg(filesData);
    const reader = new FileReader();
    reader.onload = (ev) => {
      setCertUrl(ev.target.result);
    };
    reader.readAsDataURL(e.target.files[0]);
  };

  const handleImageUploadDistinction = (e) => {
    const filesData = e.target.files[0];
    setDistinctionImg(filesData);
    const reader = new FileReader();
    reader.onload = (ev) => {
      setDistinctionUrl(ev.target.result);
    };
    reader.readAsDataURL(e.target.files[0]);
  };

  const handleAllowAssignable = (e) => {
    setIsAssignable(e.target.checked);
  };

  const handleVideoClear = () => {
    setVideoFile(null);
    setVideoUrl('');
  };
  // Get today's date
  const today = new Date();

  return (
    <Grid className={classes.certBox}>
      <Grid>
        <Grid style={{ display: 'flex', width: '97%', justifyContent: 'space-between' }}>
          <Typography className={classes.optional_field}>Certificate Is For Assigning Only</Typography>
          <AntSwitch
            checked={isAssignable}
            onChange={handleAllowAssignable}
            inputProps={{ 'aria-label': 'ant design' }}
          />
        </Grid>
      </Grid>
      <Grid>
        <Grid style={{ display: 'flex', width: '97%', justifyContent: 'space-between' }}>
          <Typography className={classes.required_field}>Certification Code</Typography>
          <Typography style={{ color: '#667085', fontSize: '14px' }}> {certInfo.code?.length} / 8</Typography>
        </Grid>
        <input
          placeholder="ex: CC101"
          className={classes.inputField}
          value={certInfo.code}
          onChange={(e) => handleChange(e, 'code')}
        />
      </Grid>
      <Grid style={{ width: '100%' }}>
        <Grid style={{ display: 'flex', width: '97%', justifyContent: 'space-between' }}>
          <Typography className={classes.required_field}>Certification Title</Typography>
          <Typography style={{ color: '#667085', fontSize: '14px' }}> {certInfo.name?.length} / 50</Typography>
        </Grid>
        <input
          placeholder="ex: EV Roadtrip"
          className={classes.inputField}
          value={certInfo.name}
          onChange={(e) => handleChange(e, 'name')}
        />
      </Grid>
      <Grid style={{ width: '100%' }}>
        <Grid style={{ display: 'flex', width: '97%', justifyContent: 'space-between' }}>
          <Typography className={classes.optional_field}>Certification Reporting Code</Typography>
          <Typography style={{ color: '#667085', fontSize: '14px' }}>
            {certInfo.courseCode?.length} / {REPORTING_CODE_CHAR_LIMIT}
          </Typography>
        </Grid>
        <input
          placeholder="ex: 12345"
          className={classes.inputField}
          value={certInfo.courseCode}
          onChange={(e) => handleChange(e, 'courseCode')}
        />
      </Grid>
      <Grid style={{ width: '100%' }}>
        <Grid className={classes.charLimit}>
          <Typography className={classes.required_field}>Overview</Typography>
          <Typography style={{ color: '#667085', fontSize: '14px' }}> {certInfo.overview?.length} / 150</Typography>
        </Grid>
        <input
          placeholder="Enter certification overview here"
          className={classes.inputField}
          value={certInfo.overview}
          onChange={(e) => handleChange(e, 'overview')}
        />
      </Grid>
      <Grid>
        <Typography className={classes.required_field}>Duration (in days)</Typography>
        <input
          placeholder="Enter duration here"
          className={classes.inputField}
          value={certInfo.duration}
          onChange={(e) => handleChange(e, 'duration')}
        />
      </Grid>

      <Grid>
        <Typography className={classes.optional_field}>Expiry Date</Typography>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDatePicker
            placeholder="YYYY-MM-DD"
            value={expDate}
            disabled={isEdit && selectedCertInfoEdit?.editWarning}
            onChange={setExpDate}
            InputProps={{
              disableUnderline: true,
              classes: {
                input: 'date-field',
              },
            }}
            format="yyyy-MM-dd"
            style={{
              width: '95%',
              backgroundColor: 'white',
              height: '30px',
              borderRadius: 8,
              padding: '10px',
              marginTop: '8px',
            }}
            minDate={today}
          />
        </MuiPickersUtilsProvider>
      </Grid>

      <Grid>
        <Typography className={classes.required_field}>Departments</Typography>
        <FormControl className={classes.upload}>
          <MultiSelectAll
            placeholderButtonLabel="Select a department"
            selectedOptions={selectedDeptIds || []}
            onChange={handleMultiDept}
            options={deptList || []}
            width="100%"
          />
        </FormControl>
      </Grid>
      <Grid>
        <Typography className={classes.optional_field}>Passed Certificate Background </Typography>
        <Grid className={classes.upload}>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Chip
              className={classes.chip}
              onDelete={certUrl ? handleDeletePassedCert : undefined}
              deleteIcon={certUrl ? undefined : <span>&times;</span>}
              label={
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Image alt="" src={certUrl || ''} style={{ height: '26px' }} loading="lazy" />
                  <span>{certImg?.name}</span>
                </div>
              }
            />
            <Grid>
              <UploadButton
                disableElevation
                className={classes.btnUploadStyle}
                handleImageUpload={handleImageUpload}
                id="passing-background"
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid>
        <Typography className={classes.required_field}>Thumbnail </Typography>
        <CustomUploadField
          type="image"
          name="thumbnail"
          value={thumbnailImg ? thumbnailUrl : null}
          imgSrc={!thumbnailImg ? thumbnailUrl : null}
          handleChange={handleThumbnailUpload}
          customStyles={{ width: '100%' }}
          fileName={thumbnailImg?.name}
          dimensions={DIMENSIONS.certification}
          handleDelete={handleDeleteThumbnail}
        />
      </Grid>
      <Grid>
        <Typography className={classes.optional_field}>Distinction Certificate Background </Typography>
        <Grid className={classes.upload}>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Chip
              className={classes.chip}
              onDelete={distinctionUrl ? handleDeleteDistCert : undefined}
              deleteIcon={distinctionUrl ? undefined : <span>&times;</span>}
              label={
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Image alt="" src={distinctionUrl || ''} style={{ height: '26px' }} loading="lazy" />
                  <span>{distinctionImg?.name}</span>
                </div>
              }
            />
            <Grid>
              <UploadButton
                disableElevation
                className={classes.btnUploadStyle}
                handleImageUpload={handleImageUploadDistinction}
                id="distinction-background"
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid>
        <Typography className={classes.optional_field}>Pre-Requisite Certificates</Typography>
        <FormControl className={classes.upload}>
          <MultiSelectAll
            placeholderButtonLabel="Select pre-requisites certificates"
            selectedOptions={selectedCertIds || []}
            onChange={handleMultiCert}
            options={certList || []}
            width="100%"
          />
        </FormControl>
      </Grid>
      <Grid>
        <Typography className={classes.optional_field}>Post Completion Video</Typography>
        <Grid className={classes.upload}>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Grid style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
              {videoUrl && (
                <video src={videoUrl} style={{ height: '50px' }} controls>
                  <track kind="captions" src="" label="No captions available" />
                </video>
              )}

              <p>{videoFile?.name}</p>
            </Grid>
            <Grid>
              <VideoUploadButton
                className={classes.btnUploadStyle}
                setVideoFile={setVideoFile}
                setVideoUrl={setVideoUrl}
                id="post-completion-video"
              />
            </Grid>
          </Grid>
        </Grid>
        {videoFile || videoUrl ? (
          <Typography onClick={handleVideoClear} style={{ color: 'tomato', fontSize: '14px', cursor: 'pointer' }}>
            remove video
          </Typography>
        ) : null}
      </Grid>

      <Grid style={{ display: 'flex', gap: '40px' }}>
        <Typography className={classes.required_field}>Skill Level </Typography>
        <Grid className={classes.skill}>
          <Radio
            className={classes.radioBtn}
            checked={certInfo.skillLevelId === 1}
            onClick={() => {
              setCertInfo((pre) => ({
                ...pre,
                skillLevelId: 1,
              }));
            }}
            style={{ ...(certInfo.skillLevelId === 1 ? { color: '#622fee' } : {}) }}
          />
          <Typography className={classes.optional_field}>Beginner </Typography>
        </Grid>
        <Grid className={classes.skill}>
          <Radio
            className={classes.radioBtn}
            checked={certInfo.skillLevelId === 2}
            onClick={() => {
              setCertInfo((pre) => ({
                ...pre,
                skillLevelId: 2,
              }));
            }}
            style={{ ...(certInfo.skillLevelId === 2 ? { color: '#622fee' } : {}) }}
          />
          <Typography className={classes.optional_field}>Intermediate </Typography>
        </Grid>
        <Grid className={classes.skill}>
          <Radio
            className={classes.radioBtn}
            checked={certInfo.skillLevelId === 3}
            onClick={() => {
              setCertInfo((pre) => ({
                ...pre,
                skillLevelId: 3,
              }));
            }}
            style={{ ...(certInfo.skillLevelId === 3 ? { color: '#622fee' } : {}) }}
          />
          <Typography className={classes.optional_field}>Expert </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};
